/* Premium Grounding native cart drawer. Replaces Rebuy Smart Cart.
 *
 * Registers the <cart-drawer> custom element that Dawn's product-form.js and
 * pg-buy-box.liquid already talk to (renderContents / getSectionsToRender /
 * setActiveElement), so every existing add-to-cart path opens this drawer with
 * no theme JS changes elsewhere.
 *
 * Config comes from window.PG_CART_CONFIG (snippets/pg-cart-drawer.liquid):
 *   offers   = shop.metafields.pg_cart.offers (same JSON the discount function reads)
 *   country, currency, rate, locale, px (event collector), clientId (_shopify_y)
 *
 * Gifts: the drawer adds/removes gift lines carrying the `_pg_gift` line property;
 * the pg-offers discount function prices them at 100% off; pg-gift-guard blocks
 * checkout if a gift line stops qualifying. rules() below mirrors rules.js in the
 * app so both sides agree.
 */
(function () {
  'use strict';
  if (window.__pgCartLoaded) return;
  window.__pgCartLoaded = true;

  var CFG = window.PG_CART_CONFIG || {};
  var OFFERS = CFG.offers || { offers: [], products: {} };
  var PRODUCTS = OFFERS.products || {};
  var CATALOG = PRODUCTS.catalog || {};
  var COUNTRY = CFG.country || '';
  var CURRENCY = CFG.currency || 'AUD';
  var RATE = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || CFG.rate || 1) || 1;
  var LOCALE = CFG.locale || 'en-AU';
  var PX = CFG.px || '';
  var CLIENT_ID = (document.cookie.match(/(?:^|; )_shopify_y=([^;]+)/) || [])[1] || CFG.clientId || '';
  var ROUTES = window.routes || {};
  var ROOT = (ROUTES.cart_url || '/cart').replace(/\/cart$/, '');
  var T = CFG.strings || {};

  /* ---------------------------------------------------------------- journey (2026-10-14)
     First visit, latest marketing touch and blog articles read, kept in this browser (localStorage)
     and written to the order as hidden cart attributes (_pg_ft, _pg_lt, _pg_arts, _pg_v), so every
     order carries its own history even when the tracking pixel misses it (ad blockers, consent,
     outages). Read by tw-replacement/content.py and attribution2.py. Format of _pg_ft / _pg_lt:
     date|source|medium|campaign|ad|landing path. Fail-safe: any error leaves the cart untouched. */
  var JOURNEY = (function () {
    var KEY = 'pg_journey_v1', MAX_ARTS = 15, TTL = 180 * 864e5, j = null, now = Date.now();
    try {
      try { j = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { j = null; }
      if (!j || !j.ft || (now - j.ft.t) > TTL) j = { ft: null, lt: null, a: [], v: 0, lv: 0 };
      var q = {}; location.search.replace(/^\?/, '').split('&').forEach(function (kv) { if (!kv) return; var i = kv.indexOf('='); try { q[decodeURIComponent(i < 0 ? kv : kv.slice(0, i))] = decodeURIComponent(i < 0 ? '' : kv.slice(i + 1).replace(/\+/g, ' ')); } catch (e) {} });
      var ref = ''; try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
      var internal = !ref || /premiumgrounding|shopify|myshopify|paypal|afterpay|klarna|zip\.co/.test(ref);
      var paidG = q.gclid || q.gbraid || q.wbraid || q.tw_adid;
      var src = q.utm_source || q.tw_source || (paidG ? 'google' : '') || (q.fbclid ? 'facebook' : '') || (internal ? '' : ref);
      var cut = function (x, n) { return String(x || '').replace(/\|/g, '/').slice(0, n); };
      var touch = src ? { t: now, s: cut(src, 40), m: cut(q.utm_medium || (paidG ? 'cpc' : q.fbclid ? 'paid' : 'referral'), 20),
        c: cut(q.utm_campaign || q.tw_campaign, 60), ad: cut(q.utm_content || q.tw_adid, 40), p: cut(location.pathname, 120) } : null;
      if (!j.ft) j.ft = touch || { t: now, s: 'direct', m: '', c: '', ad: '', p: cut(location.pathname, 120) };
      if (touch) j.lt = touch;
      if (now - (j.lv || 0) > 30 * 60 * 1000) j.v = (j.v || 0) + 1;
      j.lv = now;
      var m = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/, '').match(/^\/blogs\/[^/]+\/([^/?#]+)/);
      if (m && j.a.indexOf(m[1]) === -1) { j.a.push(m[1]); if (j.a.length > MAX_ARTS) j.a.shift(); }
      try { localStorage.setItem(KEY, JSON.stringify(j)); } catch (e) {}
    } catch (e) { j = null; }
    function fmt(x) { return x ? [new Date(x.t).toISOString().slice(0, 10), x.s, x.m, x.c, x.ad, x.p].join('|').slice(0, 250) : ''; }
    return { attrs: function () {
      if (!j || !j.ft) return {};
      var o = { _pg_ft: fmt(j.ft), _pg_v: String(j.v || 1) };
      if (j.lt) o._pg_lt = fmt(j.lt);
      if (j.a && j.a.length) o._pg_arts = j.a.join(',').slice(0, 900);
      return o;
    } };
  })();

  /* ---------------------------------------------------------------- rules (mirror of app rules.js) */
  /* Daily allocation cap: mirror of capReached() in the app rules.js. DAILY comes from
     window.PG_CART_CONFIG.daily = shop.metafields.pg_cart.daily_counts (written by the Reset
     server counter). Fail open: no row, no count, or a row whose expires_at (the country's next
     local midnight) is missing, unparseable or already past = NOT reached, so a dead counter or
     a missed rollover can never hold the cap on.
     2026-09-29: a capped offer is only not ADDED. evalOffers still lists it (capped:true) so a
     gift already in the cart is kept, and the checkout functions honour it at $0; the cap never
     blocks or reprices a sheet order. */
  var DAILY = (typeof CFG !== 'undefined' && CFG && CFG.daily) || {};
  function capReached(o) {
    var cap = o && o.daily_cap && Number(o.daily_cap.per_country);
    if (!cap) return false;
    var now = Date.now(), offs = o.daily_cap.off_windows || [];
    for (var i = 0; i < offs.length; i++) { if (windowActive(offs[i], now) && countryMatch(offs[i].countries, COUNTRY)) return false; }
    var row = DAILY[COUNTRY];
    if (!row || row.count == null) return false;
    var exp = row.expires_at ? Date.parse(row.expires_at) : NaN;
    if (!(exp > now)) return false;
    return Number(row.count) >= cap;
  }
  /* cap_with (James 2026-10-07, AU/NZ BOGO relaunch): an offer that names another offer's id rides on
     THAT offer's daily cap, so "today's first 50 orders get the warranty, second sheet and Reset app"
     stays true: once the warranty stops being added, the free sheet and the Reset stop too. Same fail-open
     rules as capReached (it is capReached of the named offer). A missing target = not capped. */
  function capOf(o) {
    if (o && o.cap_with) {
      var t = (OFFERS.offers || []).filter(function (x) { return x && x.id === o.cap_with; })[0];
      return t ? capReached(t) : false;
    }
    return capReached(o);
  }
  /* Country semantics (same in rules.js, Checkout.jsx, sync.py, live_guard.py):
   *   ["*"]          every country
   *   ["AU","NZ"]    only those
   *   []             NO country (an empty list switches the offer/window off)
   *   key missing    every country (legacy shape; sync.py refuses to push it)
   * 2026-09-23: [] used to mean "every country", which ran the BOGO base offer
   * always-on in all markets and gave away 53 free King sheets. */
  function countryMatch(list, c) {
    if (list === undefined || list === null) return true;
    if (!Array.isArray(list)) return false;
    return list.indexOf('*') !== -1 || (!!c && list.indexOf(c) !== -1);
  }
  /* Local-time windows (BFCM 2026, James 2026-10-27): w.local = [[starts_at, ends_at, "CC CC *"], ...].
     The first entry naming this country decides, else the '*' entry. Same rule as rules.js
     localEntry, where the discount function asks dateTimeBetween for the same pair. */
  function localEntry(w, c) {
    var es = (w && w.local) || [], i;
    for (i = 0; i < es.length; i++) { if (c && String(es[i][2] || '').split(' ').indexOf(c) !== -1) return es[i]; }
    for (i = 0; i < es.length; i++) { if (String(es[i][2] || '').split(' ').indexOf('*') !== -1) return es[i]; }
    return null;
  }
  function windowActive(w, now) {
    if (!w) return false;
    var e = w.local && localEntry(w, COUNTRY);
    if (e) return now >= Date.parse(e[0]) && now < Date.parse(e[1]);
    if (w.starts_at && now < Date.parse(w.starts_at)) return false;
    if (w.ends_at && now > Date.parse(w.ends_at)) return false;
    return true;
  }
  function thresholdFor(min, currency, rate) {
    if (!min) return Infinity;
    if (min[currency] != null) return Number(min[currency]);
    if (min.AUD != null) return Number(min.AUD) * rate;
    var vals = Object.keys(min).map(function (k) { return min[k]; });
    return vals.length ? Number(vals[0]) : Infinity;
  }
  function variantSet(gift) {
    var ids = {};
    if (gift.variant_id) ids[Number(gift.variant_id)] = 1;
    var cat = gift.catalog_key && CATALOG[gift.catalog_key];
    if (cat) {
      if (cat.variant_id) ids[Number(cat.variant_id)] = 1;
      if (cat.variant_by_plug) Object.keys(cat.variant_by_plug).forEach(function (k) { ids[Number(cat.variant_by_plug[k])] = 1; });
    }
    return ids;
  }
  function titleHasAny(title, values) {
    if (!values || !values.length) return false;
    var t = String(title || '');
    return values.some(function (v) { return t.indexOf(v) !== -1; });
  }
  function giftVariantFor(gift, plug) {
    if (gift.variant_id) return Number(gift.variant_id);
    var cat = gift.catalog_key && CATALOG[gift.catalog_key];
    if (!cat) return null;
    if (cat.variant_id) return Number(cat.variant_id);
    var m = cat.variant_by_plug || {};
    return Number(m[plug] || m['AUS/NZ'] || Object.keys(m).map(function (k) { return m[k]; })[0]) || null;
  }
  function evalOffers(lines, plug) {
    var now = Date.now();
    var prot = PRODUCTS.protection || {};
    var paid = lines.filter(function (l) { return !l.gift && !l.rebuyGift && !l.isProtection && Number(l.variantId) !== Number(prot.variant_id); });
    var subtotal = paid.reduce(function (s, l) { return s + l.subtotal; }, 0);
    var desired = [], bar = null, tiers = [];
    (OFFERS.offers || []).forEach(function (o) {
      if (!o || o.enabled === false) return;
      if (o.type === 'gift_with_product') {
        if (!countryMatch(o.countries, COUNTRY)) return;
        var capped = capOf(o);
        var trig = o.trigger || {};
        var qty = paid.filter(function (l) { return Number(l.productId) === Number(trig.product_id); }).reduce(function (s, l) { return s + l.qty; }, 0);
        if (qty >= (trig.min_qty || 1)) desired.push({ offer_id: o.id, gift_key: o.id, variant_ids: variantSet(o.gift), variant_id: giftVariantFor(o.gift, plug), qty: o.gift.qty || 1, product_id: Number(o.gift.product_id), title: o.gift.title, subtitle: o.gift.subtitle, capped: capped });
      }
      if (o.type === 'bogo') {
        var active = countryMatch(o.countries, COUNTRY), include = [];
        (o.windows || []).forEach(function (w) { if (windowActive(w, now) && countryMatch(w.countries, COUNTRY)) { active = true; include = include.concat(w.include_option_values || []); } });
        if (!active) return;
        var tg = o.trigger || {};
        var exclude = (tg.exclude_option_values || []).filter(function (v) { return include.indexOf(v) === -1; });
        var q = paid.filter(function (l) { return Number(l.productId) === Number(tg.product_id) && !titleHasAny(l.variantTitle, exclude); }).reduce(function (s, l) { return s + l.qty; }, 0);
        if (q >= (tg.min_qty || 1)) desired.push({ offer_id: o.id, gift_key: o.id, variant_ids: variantSet(o.gift), variant_id: giftVariantFor(o.gift, plug), qty: o.gift.qty || 1, product_id: Number(o.gift.product_id), title: o.gift.title, subtitle: o.gift.subtitle, capped: capOf(o) });
      }
      if (o.type === 'progress_bar') {
        var b = (o.bars || []).filter(function (x) { return countryMatch(x.countries, COUNTRY); })[0];
        if (!b) return;
        bar = b;
        tiers = (b.tiers || []).map(function (t) {
          var th = thresholdFor(t.min, CURRENCY, RATE);
          return { type: t.type, threshold: th, reached: subtotal >= th - 0.005, remaining: Math.max(0, th - subtotal), label: t.label || '', gift: t.gift || null };
        });
        (b.tiers || []).forEach(function (t, i) {
          if (t.type === 'gift' && tiers[i].reached && t.gift) desired.push({ offer_id: o.id, gift_key: 'tier_gift', variant_ids: variantSet(t.gift), variant_id: giftVariantFor(t.gift, plug), qty: t.gift.qty || 1, product_id: Number(t.gift.product_id), title: t.gift.title, subtitle: t.gift.subtitle || 'Unlocked by your order value' });
        });
      }
    });
    return { desired: desired, subtotal: subtotal, bar: bar, tiers: tiers, paid: paid };
  }

  /* ---------------------------------------------------------------- utils */
  var fmtCache = {};
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      if (!fmtCache[CURRENCY]) fmtCache[CURRENCY] = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY, currencyDisplay: 'narrowSymbol' });
      return fmtCache[CURRENCY].format(n);
    } catch (e) {
      return CURRENCY + ' ' + n.toFixed(2);
    }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + (w || 200) + 'x$1$2'); }
  function hash32(s) { var h = 2166136261; s = String(s); for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(seed) { var a = seed >>> 0; return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function gammaSample(r, k) {
    if (k < 1) return gammaSample(r, k + 1) * Math.pow(Math.max(r(), 1e-9), 1 / k);
    var d = k - 1 / 3, c = 1 / Math.sqrt(9 * d);
    for (;;) {
      var x, v;
      do { var u1 = Math.max(r(), 1e-9), u2 = r(); x = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2); v = 1 + c * x; } while (v <= 0);
      v = v * v * v; var u = r();
      if (u < 1 - 0.0331 * x * x * x * x) return d * v;
      if (Math.log(u) < 0.5 * x * x + d * (1 - v + Math.log(v))) return d * v;
    }
  }
  function betaSample(r, a, b) { var x = gammaSample(r, a), y = gammaSample(r, b); return x / (x + y); }
  function plugOf(l) {
    var o = l.options || {};
    var p = o['Plug Type'] || o['Plug type'];
    if (!p) return null;
    p = String(p); return /aus/i.test(p) ? 'AUS/NZ' : p;
  }
  function plugFromLines(lines) {
    var sheetId = Number(PRODUCTS.sheet_product_id || 0);
    var paidSheets = lines.filter(function (l) { return !l.gift && !l.rebuyGift && Number(l.productId) === sheetId; });
    var i, p;
    for (i = 0; i < paidSheets.length; i++) { p = plugOf(paidSheets[i]); if (p) return p; }
    for (i = 0; i < lines.length; i++) { if (lines[i].gift || lines[i].rebuyGift) continue; p = plugOf(lines[i]); if (p) return p; }
    return (PRODUCTS.plug_by_country || {})[COUNTRY] || (PRODUCTS.plug_by_currency || {})[CURRENCY] || 'AUS/NZ';
  }
  function normLines(cart) {
    var prot = PRODUCTS.protection || {};
    return (cart.items || []).map(function (it) {
      var props = it.properties || {};
      var options = {};
      (it.options_with_values || []).forEach(function (ov) { options[ov.name] = ov.value; });
      return {
        key: it.key, raw: it, qty: it.quantity, productId: it.product_id, variantId: it.variant_id,
        variantTitle: it.variant_title || '', options: options, title: it.product_title || it.title,
        subtotal: (it.original_line_price || 0) / 100, gift: props._pg_gift ? String(props._pg_gift) : null,
        rebuyGift: props._source === 'Rebuy', src: props._pg_src || null,
        isProtection: Number(it.variant_id) === Number(prot.variant_id),
        image: it.featured_image && it.featured_image.url || it.image, url: it.url,
        original: it.original_line_price, final: it.final_line_price, unit: it.final_price
      };
    });
  }

  /* ---------------------------------------------------------------- tracking */
  var dl = window.dataLayer = window.dataLayer || [];
  function track(name, data) {
    var p = Object.assign({ event: 'pg_cart_' + name, ts: new Date().toISOString(), client_id: CLIENT_ID, url: location.href, referrer: document.referrer, currency: CURRENCY, country: COUNTRY, cart_v: 'v1', holdout: state.holdout ? 1 : 0, cart_total: state.cart ? state.cart.total_price / 100 : null, item_count: state.cart ? state.cart.item_count : null }, data || {});
    try { dl.push(Object.assign({}, p)); } catch (e) {}
    if (!PX || !CLIENT_ID) return;
    try { fetch(PX, { method: 'POST', keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(p) }).catch(function () {}); } catch (e) {}
  }

  /* ---------------------------------------------------------------- Klaviyo signups (2026-10-14)
     When someone submits a Klaviyo form (popup, flyout, embed), send the email to our own collector
     with this browser's _shopify_y id. The collector stores client_id <-> email, which is the only way
     to link a phone visit to a later purchase on another device. Nothing is shown to the shopper. */
  (function () {
    var sent = {};
    function kx() { try { var c = (document.cookie.match(/(?:^|; )__kla_id=([^;]+)/) || [])[1]; if (!c) return ''; var o = JSON.parse(atob(decodeURIComponent(c))); return o.$exchange_id || ''; } catch (e) { return ''; } }
    window.addEventListener('klaviyoForms', function (e) {
      try {
        var d = e && e.detail || {};
        if (d.type !== 'submit' && d.type !== 'stepSubmit') return;
        var md = d.metaData || {};
        var email = String(md.$email || md.email || '').trim().toLowerCase();
        if (!PX || !CLIENT_ID || (!email && !kx())) return;
        var key = email || 'kx'; if (sent[key]) return; sent[key] = 1;
        var p = { event: 'pg_klaviyo_signup', ts: new Date().toISOString(), client_id: CLIENT_ID, url: location.href, referrer: document.referrer,
                  form_id: d.formId || '', country: COUNTRY };
        if (email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) p.email = email;
        var x = kx(); if (x) p.url = location.href + (location.search ? '&' : '?') + '_kx=' + encodeURIComponent(x);
        fetch(PX, { method: 'POST', keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(p) }).catch(function () {});
      } catch (err) {}
    });
  })();

  /* ---------------------------------------------------------------- cart API */
  function jfetch(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.payload = j; throw e; } return j; }); });
  }
  function getCart() { return jfetch(ROOT + '/cart.js?_=' + Date.now(), { method: 'GET' }); }
  function addItems(items) { return jfetch(ROOT + '/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) }); }
  function changeLine(key, qty) { return jfetch(ROOT + '/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) }); }
  function updateCart(body) { return jfetch(ROOT + '/cart/update.js', { method: 'POST', body: JSON.stringify(body) }); }

  /* ---------------------------------------------------------------- state */
  var state = { cart: null, lines: [], plug: 'AUS/NZ', evalr: null, busy: false, open: false, error: null, holdout: false, bucket: 0, exposed: {}, reconcilePasses: 0, failedGifts: {}, code: '', codeMsg: '', announceIdx: 0, attrsSet: false, activeElement: null };
  state.bucket = CLIENT_ID ? hash32(CLIENT_ID + ':pgcart') % 100 : 50;
  var upsellOffer = (OFFERS.offers || []).filter(function (o) { return o.type === 'upsell_slots' && o.enabled !== false && countryMatch(o.countries, COUNTRY); })[0];
  state.holdout = !!(upsellOffer && state.bucket < Number(upsellOffer.holdout_pct || 0));
  var queue = Promise.resolve();
  function enqueue(fn) { queue = queue.then(fn, fn); return queue; }

  function setCart(cart) {
    state.cart = cart;
    state.lines = normLines(cart);
    state.plug = plugFromLines(state.lines);
    state.evalr = evalOffers(state.lines, state.plug);
    updateBubble();
  }

  /* ---------------------------------------------------------------- gift reconciliation */
  function reconcile() {
    var ev = state.evalr;
    if (!ev) return Promise.resolve(false);
    var used = {};
    var removals = {};
    var adds = [];
    // 0. leftover Rebuy-added gift lines from carts built before the cutover: ours replace them
    state.lines.forEach(function (l) { if (l.rebuyGift && !l.gift) removals[l.key] = 0; });
    // 1. gift lines that no longer qualify (or wrong variant / extra qty) go
    state.lines.forEach(function (l) {
      if (!l.gift) return;
      var hit = null;
      for (var i = 0; i < ev.desired.length; i++) {
        var d = ev.desired[i];
        if (used[d.gift_key]) continue;
        if (d.gift_key === l.gift && d.variant_ids[Number(l.variantId)]) { hit = d; break; }
      }
      if (hit) {
        used[hit.gift_key] = true;
        if (!hit.capped && hit.variant_id && Number(l.variantId) !== Number(hit.variant_id) && !state.failedGifts[hit.gift_key + ':' + hit.variant_id]) {
          // plug changed since the gift was added: swap to the matching variant
          removals[l.key] = 0; used[hit.gift_key] = false;
        } else if (l.qty > hit.qty) removals[l.key] = hit.qty;
      } else removals[l.key] = 0;
    });
    // 2. desired gifts not in the cart get added (once per session per gift). A capped gift is
    //    kept if already there (step 1) but never added.
    ev.desired.forEach(function (d) {
      if (used[d.gift_key] || !d.variant_id || d.capped) return;
      var fk = d.gift_key + ':' + d.variant_id;
      if (state.failedGifts[fk]) return;
      adds.push({ id: d.variant_id, quantity: d.qty, properties: { _pg_gift: d.gift_key } });
    });
    if (!Object.keys(removals).length && !adds.length) return Promise.resolve(false);
    if (state.reconcilePasses > 3) return Promise.resolve(false);
    state.reconcilePasses++;
    var p = Promise.resolve(null);
    if (Object.keys(removals).length) p = p.then(function () { return updateCart({ updates: removals }); });
    if (adds.length) p = p.then(function () { return addItems(adds).catch(function (e) { adds.forEach(function (a) { state.failedGifts[a.properties._pg_gift + ':' + a.id] = true; }); track('gift_add_failed', { variants: adds.map(function (a) { return a.id; }), error: String(e && e.message) }); }).then(function () { return null; }); });
    return p.then(function (c) { return c && c.token ? c : getCart(); }).then(function (c) {
      setCart(c);
      Object.keys(removals).forEach(function (k) { track('gift_removed', { key: k }); });
      adds.forEach(function (a) { track('gift_added', { gift: a.properties._pg_gift, variant_id: a.id }); });
      return reconcile();
    });
  }
  function ensureAttributes() {
    if (!state.cart || !state.cart.item_count) return Promise.resolve();
    var a = state.cart.attributes || {};
    var want = { _pg_cart: 'v1', _pg_holdout: state.holdout ? '1' : '0' };
    if (CLIENT_ID) want._pg_cid = CLIENT_ID;
    var jr = JOURNEY.attrs(); Object.keys(jr).forEach(function (k) { want[k] = jr[k]; });
    var diff = Object.keys(want).some(function (k) { return a[k] !== want[k]; });
    if (!diff) return Promise.resolve();
    return updateCart({ attributes: want }).then(function (c) { setCart(c); }).catch(function () {});
  }

  function settle(cart) {
    state.reconcilePasses = 0;
    return (cart && cart.token ? Promise.resolve(cart) : getCart()).then(function (c) { setCart(c); return reconcile(); }).then(function () { return ensureAttributes(); });
  }
  // Run one cart mutation, then settle from its response (change/update return the full cart,
  // add returns only the added items, so that path re-reads once). One queue, no overlap.
  function mutate(fn, silent) {
    return enqueue(function () {
      state.busy = true; render();
      return Promise.resolve().then(fn).then(function (c) { return settle(c); })
        .catch(function (e) {
          var msg = String(e && e.message);
          // Passive refreshes (page load, tab switch, navigation away mid-fetch) must never paint a
          // red banner: "Load failed" / "Failed to fetch" / a half-read JSON body are not the customer's problem.
          var benign = /load failed|failed to fetch|networkerror|unexpected end of json|unexpected token|aborted/i.test(msg);
          if (!silent && !benign) state.error = e && e.message;
          track(silent || benign ? 'bg_error' : 'error', { error: msg });
        })
        .then(function () { state.busy = false; render(); });
    });
  }
  function refresh() { return mutate(function () { return null; }, true); }
  // Change one line's quantity and, in the same request, remove any gift line that the
  // resulting cart no longer earns. Keeps the cart valid at every step (never a stray gift).
  function changeWithGifts(key, qty) {
    var updates = {};
    updates[key] = qty;
    var simulated = state.lines.map(function (l) { return l.key === key ? Object.assign({}, l, { qty: qty }) : l; }).filter(function (l) { return l.qty > 0; });
    var ev = evalOffers(simulated, plugFromLines(simulated));
    var used = {};
    simulated.forEach(function (l) {
      if (!l.gift) return;
      var hit = null;
      for (var i = 0; i < ev.desired.length; i++) { var d = ev.desired[i]; if (!used[d.gift_key] && d.gift_key === l.gift && d.variant_ids[Number(l.variantId)]) { hit = d; break; } }
      if (hit) used[hit.gift_key] = true; else updates[l.key] = 0;
    });
    state.lines.forEach(function (l) { if (l.rebuyGift && !l.gift) updates[l.key] = 0; });
    return updateCart({ updates: updates }).catch(function (e) {
      // If Shopify still refuses (e.g. an older guard), strip every gift first, then retry.
      var strip = {}; state.lines.forEach(function (l) { if (l.gift || l.rebuyGift) strip[l.key] = 0; });
      if (!Object.keys(strip).length) throw e;
      return updateCart({ updates: strip }).then(function () { return updateCart({ updates: (function () { var u = {}; u[key] = qty; return u; })() }); });
    });
  }

  /* ---------------------------------------------------------------- bandit + upsells */
  function bogoActive() {
    var now = Date.now();
    return (OFFERS.offers || []).some(function (o) {
      if (o.type !== 'bogo' || o.enabled === false) return false;
      if (countryMatch(o.countries, COUNTRY)) return true;
      return (o.windows || []).some(function (w) { return windowActive(w, now) && countryMatch(w.countries, COUNTRY); });
    });
  }
  function paidSheetLine() {
    var sid = Number(PRODUCTS.sheet_product_id || 0);
    return state.lines.filter(function (l) { return !l.gift && !l.rebuyGift && Number(l.productId) === sid; })[0] || null;
  }
  function slotCount() { return window.innerWidth <= 520 ? (Number(upsellOffer.slots) || 3) : (Number(upsellOffer.slots_desktop) || Number(upsellOffer.slots) || 2); }
  function pickArms() {
    if (!upsellOffer || state.holdout) return [];
    var inCart = {};
    state.lines.forEach(function (l) { inCart[Number(l.productId)] = 1; });
    var day = new Date().toISOString().slice(0, 10);
    var r = rng(hash32((CLIENT_ID || 'anon') + day));
    var sheet = paidSheetLine();
    var arms = (upsellOffer.arms || []).map(function (a) {
      var cat = CATALOG[a.catalog_key];
      if (!cat) return null;
      if (cat.dynamic === 'same_as_paid_sheet') {
        if (!sheet || (a.only_without_bogo && bogoActive())) return null;
        return { key: a.key, cat: Object.assign({}, cat, { title: a.title || cat.title, image: sheet.image }), blurb: a.blurb, variantId: Number(sheet.variantId), score: betaSample(r, Number(a.alpha) || 1, Number(a.beta) || 1) };
      }
      if (upsellOffer.exclude_if_in_cart !== false && inCart[Number(cat.product_id)]) return null;
      var vid = cat.variant_id || (cat.variant_by_plug || {})[state.plug] || (cat.variant_by_plug || {})['AUS/NZ'];
      if (!vid) return null;
      return { key: a.key, cat: cat, blurb: a.blurb, variantId: Number(vid), score: betaSample(r, Number(a.alpha) || 1, Number(a.beta) || 1) };
    }).filter(Boolean);
    arms.sort(function (x, y) { return y.score - x.score; });
    var next = nextTier(state.evalr), gap = next ? Math.round(next.remaining * 100) : 0;
    if (gap > 0) {
      var closers = arms.filter(function (a) { var pc = priceCache[a.variantId]; return pc && pc.price != null && pc.price >= gap; }).sort(function (x, y) { return priceCache[x.variantId].price - priceCache[y.variantId].price; });
      if (closers.length) { arms = [closers[0]].concat(arms.filter(function (a) { return a !== closers[0]; })); }
    }
    var tailKeys = upsellOffer.pinned_tail || [];
    var tail = tailKeys.map(function (k) { return arms.filter(function (a) { return a.key === k; })[0]; }).filter(Boolean);
    var head = arms.filter(function (a) { return tailKeys.indexOf(a.key) === -1; }).slice(0, slotCount());
    return head.concat(tail);
  }
  var priceCache = {};
  function variantPrice(vid) {
    if (priceCache[vid]) return Promise.resolve(priceCache[vid]);
    return fetch(ROOT + '/variants/' + vid + '.json', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var v = j.product_variant || j.variant || j;
      var p = { price: Math.round(Number(v.price) * 100), available: v.available !== false, image: v.featured_image && v.featured_image.src };
      priceCache[vid] = p; return p;
    }).catch(function () { return { price: null, available: true }; });
  }

  /* ---------------------------------------------------------------- render (v2, spec: DESIGN-REVIEW.md) */
  var el, body, footer, band, toastEl, toastTimer;
  var RATINGS = CFG.ratings || {};
  function q(sel, root) { return (root || el).querySelector(sel); }
  function stars(pid) {
    var r = RATINGS[String(pid)];
    if (!r || !r.count) return '';
    var pct = Math.max(0, Math.min(100, (Number(r.rating) / 5) * 100));
    return '<div class="pg-cart__rating"><span class="pg-cart__stars" style="--r:' + pct.toFixed(0) + '%"><i></i></span><span>' + Number(r.rating).toFixed(1) + ' (' + Number(r.count).toLocaleString() + ')</span></div>';
  }
  function rewardName(t) { return t.type === 'shipping' ? 'free shipping' : 'a FREE ' + esc((t.gift && t.gift.title) || t.label || 'gift'); }
  function nextTier(ev) { return (ev && ev.tiers || []).filter(function (t) { return !t.reached; })[0] || null; }
  function renderBand(ev) {
    if (!band) return;
    if (!ev || !ev.bar || !ev.tiers.length || !state.cart || !state.cart.item_count) { band.innerHTML = ''; band.classList.remove('is-done'); return; }
    var tiers = ev.tiers, max = tiers[tiers.length - 1].threshold, sub = ev.subtotal;
    var pct = max > 0 ? Math.min(100, Math.round(sub / max * 100)) : 0;
    var next = nextTier(ev), msg;
    if (next) msg = '<b>' + money(next.remaining * 100) + '</b> to <span class="pg-cart__reward">' + rewardName(next) + '</span>';
    else msg = '<b>' + tiers.map(function (t) { return t.type === 'shipping' ? 'Free shipping' : 'free ' + esc((t.gift && t.gift.title) || t.label || 'gift'); }).join(' + ') + '</b> unlocked';
    var marks = tiers.map(function (t) {
      var left = max > 0 ? Math.min(100, Math.round(t.threshold / max * 100)) : 100;
      return '<span class="pg-cart__tier' + (t.reached ? ' is-reached' : '') + '" style="left:' + left + '%"><i></i><em>' + esc(t.type === 'shipping' ? 'Free shipping' : (t.label || 'Free gift')) + '</em></span>';
    }).join('');
    band.classList.toggle('is-done', !next);
    band.innerHTML = '<p class="pg-cart__band-msg" role="status">' + msg + '</p><div class="pg-cart__bar"><div class="pg-cart__bar-fill" style="width:' + pct + '%"></div>' + marks + '</div>';
  }
  function renderTeaser(ev) {
    var next = nextTier(ev);
    if (!next || next.type !== 'gift' || !next.gift) return '';
    var cat = next.gift.catalog_key && CATALOG[next.gift.catalog_key];
    var r = cat && RATINGS[String(cat.product_id)];
    var image = (r && r.image) || (cat && cat.image) || '';
    return '<div class="pg-cart__teaser">' + (image ? '<img src="' + esc(img(image, 160)) + '" alt="" loading="eager" width="56" height="56">' : '<span></span>') + '<div><div class="pg-cart__teaser-title">Free ' + esc(next.gift.title || next.label) + '</div><div class="pg-cart__teaser-sub">Unlocks at ' + money(next.threshold * 100) + ' · ' + money(next.remaining * 100) + ' to go</div></div><span class="pg-cart__teaser-tag">Locked</span></div>';
  }
  /* 2026-10-19 (James): market bed-size names, display only (same map as the pg-buy-box pills). */
  function sizeLabel(v) {
    var m = (COUNTRY === 'US' || COUNTRY === 'CA') ? 'us' : (COUNTRY === 'GB' || COUNTRY === 'IE') ? 'uk' : COUNTRY === 'NZ' ? 'nz' : 'au';
    var L = {
      us: { 'Single/Twin': 'Twin', 'King Single/Twin XL': 'Twin XL', 'Double': 'Full', 'Super King': 'Cal King' },
      uk: { 'Single/Twin': 'Single', 'King Single/Twin XL': 'Small Double', 'Super King': 'Super King / Emperor' },
      nz: { 'Single/Twin': 'Single', 'King Single/Twin XL': 'King Single', 'Super King': 'Super King / Californian King' },
      au: { 'Single/Twin': 'Single', 'King Single/Twin XL': 'King Single' }
    }[m];
    return L[v] || v;
  }
  function prettyVariant(l) {
    var o = l.options || {};
    if (!Object.keys(o).length) return l.variantTitle;
    var parts = [];
    Object.keys(o).forEach(function (k) {
      var v = String(o[k]); var kl = k.toLowerCase();
      if (/plug/.test(kl)) parts.push(v + ' plug');
      else if (/warranty/.test(kl)) parts.push(v.toLowerCase() + ' warranty');
      else if (/size/.test(kl)) parts.push(sizeLabel(v));
      else parts.push(v);
    });
    return parts.join(' \u00b7 ');
  }
  function renderLine(l) {
    var isGift = !!l.gift || l.rebuyGift || (l.final === 0 && l.original > 0);
    var opt = l.variantTitle && l.variantTitle !== 'Default Title' ? '<div class="pg-cart__line-variant">' + esc(prettyVariant(l)) + '</div>' : '';
    var note = '';
    if (isGift) {
      var d = (state.evalr.desired || []).filter(function (x) { return x.gift_key === l.gift; })[0];
      note = '<div class="pg-cart__line-note">' + esc((d && d.subtitle) || 'Included free with your order') + '</div>';
    }
    var price = isGift
      ? '<span class="pg-cart__free">FREE</span><s>' + money(l.original) + '</s>'
      : (l.final < l.original ? '<span>' + money(l.final) + '</span><s>' + money(l.original) + '</s>' : '<span>' + money(l.final) + '</span>');
    var controls = isGift ? ''
      : l.isProtection ? '<div class="pg-cart__line-row"><button type="button" class="pg-cart__remove" data-remove="' + esc(l.key) + '">Remove</button></div>'
      : '<div class="pg-cart__line-row"><div class="pg-cart__qty" data-key="' + esc(l.key) + '"><button type="button" class="pg-cart__qty-btn" data-qty="' + (l.qty - 1) + '" aria-label="Decrease quantity">&minus;</button><span class="pg-cart__qty-val" aria-live="polite">' + l.qty + '</span><button type="button" class="pg-cart__qty-btn" data-qty="' + (l.qty + 1) + '" aria-label="Increase quantity">+</button></div><button type="button" class="pg-cart__remove" data-remove="' + esc(l.key) + '" aria-label="Remove ' + esc(l.title) + '">Remove</button></div>';
    return '<li class="pg-cart__line' + (isGift ? ' is-gift' : '') + '" data-key="' + esc(l.key) + '">' +
      '<div class="pg-cart__line-img">' + (l.image ? '<img src="' + esc(img(l.image, 200)) + '" alt="" loading="eager" width="88" height="88">' : '') + (isGift ? '<span class="pg-cart__pill">Gift</span>' : '') + '</div>' +
      '<div class="pg-cart__line-main"><div class="pg-cart__line-title">' + esc(l.title) + '</div>' + (isGift ? '' : stars(l.productId)) + opt + note + controls + '</div>' +
      '<div class="pg-cart__line-price">' + price + '</div></li>';
  }
  var SKELETON_ROW = '<li class="pg-cart__line is-pending"><div class="pg-cart__line-img"></div><div class="pg-cart__line-main"><div class="pg-cart__sk" style="width:70%"></div><div class="pg-cart__sk" style="width:45%"></div></div><div class="pg-cart__line-price"><div class="pg-cart__sk" style="width:56px"></div></div></li>';
  function pendingRow() {
    var a = state.addingInfo;
    if (!a || !a.title) return SKELETON_ROW;
    return '<li class="pg-cart__line is-pending"><div class="pg-cart__line-img">' + (a.image ? '<img src="' + esc(a.image) + '" alt="" width="88" height="88">' : '') + '</div><div class="pg-cart__line-main"><div class="pg-cart__line-title">' + esc(a.title) + '</div><div class="pg-cart__line-variant">Adding to your cart\u2026</div></div><div class="pg-cart__line-price"><span>' + esc(a.price || '') + '</span></div></li>';
  }
  function renderPendingGifts(ev, giftLines) {
    if (!state.busy || !ev) return '';
    var have = {};
    giftLines.forEach(function (l) { have[l.gift] = 1; });
    var sheet = paidSheetLine();
    return (ev.desired || []).filter(function (d) { return !d.capped && !have[d.gift_key] && !state.failedGifts[d.gift_key + ':' + d.variant_id]; }).map(function (d) {
      var r = RATINGS[String(d.product_id)];
      var w = PRODUCTS.warranty || {};
      var image = Number(d.product_id) === Number(w.product_id) ? w.image : (Number(d.product_id) === Number(PRODUCTS.sheet_product_id) && sheet ? sheet.image : (r && r.image));
      return '<li class="pg-cart__line is-gift is-pending"><div class="pg-cart__line-img">' + (image ? '<img src="' + esc(img(image, 200)) + '" alt="" width="88" height="88">' : '') + '<span class="pg-cart__pill">Gift</span></div><div class="pg-cart__line-main"><div class="pg-cart__line-title">' + esc(d.title || 'Free gift') + '</div><div class="pg-cart__line-note">' + esc(d.subtitle || 'Included free with your order') + '</div></div><div class="pg-cart__line-price"><span class="pg-cart__free">FREE</span></div></li>';
    }).join('');
  }
  function renderProtection() {
    var offer = (OFFERS.offers || []).filter(function (o) { return o.type === 'protection' && o.enabled !== false && countryMatch(o.countries, COUNTRY) && o.show_in_cart !== false; })[0];
    var prot = PRODUCTS.protection;
    if (!offer || !prot || !prot.variant_id) return '';
    var line = state.lines.filter(function (l) { return l.isProtection; })[0];
    var price = line ? money(line.final) : (priceCache[prot.variant_id] ? money(priceCache[prot.variant_id].price) : '');
    return '<label class="pg-cart__protect"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2.5l8 3v6c0 5-3.4 8.6-8 10-4.6-1.4-8-5-8-10v-6l8-3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M8.5 12l2.3 2.3L15.5 9.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="pg-cart__protect-text"><b>' + esc(prot.title || 'Shipping Protection') + '</b>' + (price ? '<span class="pg-cart__protect-price">' + price + '</span>' : '') + '<small>' + esc(prot.copy || '') + '</small></span><input type="checkbox" data-protect ' + (line ? 'checked' : '') + '><span class="pg-cart__box"></span></label>';
  }
  function armPrice(a) { var pc = priceCache[a.variantId]; return pc && pc.price != null ? pc.price : null; }
  function renderHero() {
    var h = upsellOffer && upsellOffer.hero_sheet;
    if (!h || h.enabled === false || state.holdout) return '';
    var sid = Number(PRODUCTS.sheet_product_id || 0);
    if (state.lines.some(function (l) { return Number(l.productId) === sid; })) return '';
    var r = RATINGS[String(sid)] || {};
    return '<div class="pg-cart__label">Start here</div><a class="pg-cart__hero" href="' + esc(r.url || CFG.shopUrl || '/products/grounding-earthing-sheet') + '">' + (r.image ? '<img src="' + esc(img(r.image, 200)) + '" alt="">' : '') + '<span><span class="pg-cart__hero-title">' + esc(h.title || 'Premium Grounding Sheets') + '</span>' + stars(sid) + '<span class="pg-cart__hero-sub">' + esc(h.sub || '') + '</span></span><span class="pg-cart__hero-cta">' + esc(h.cta || 'Choose size') + ' &rarr;</span></a>';
  }
  function renderUpsells(arms, ev) {
    if (!arms.length) return '';
    var next = nextTier(ev), gapCents = next ? Math.round(next.remaining * 100) : null;
    var cards = arms.map(function (a) {
      var pc = priceCache[a.variantId];
      var price = pc && pc.price != null ? money(pc.price) : '';
      var r = RATINGS[String(a.cat.product_id)];
      var image = (r && r.image) || (pc && pc.image) || a.cat.image;
      var unlocks = gapCents != null && pc && pc.price != null && pc.price >= gapCents && gapCents > 0;
      return '<li class="pg-cart__card" data-arm="' + esc(a.key) + '">' +
        '<div class="pg-cart__card-img">' + (image ? '<img src="' + esc(img(image, 400)) + '" alt="" loading="eager">' : '') + '</div>' +
        (unlocks ? '<span class="pg-cart__unlock">Unlocks ' + esc(next.type === 'shipping' ? 'free shipping' : ((next.gift && (next.gift.short_title || next.gift.title)) || 'free gift')) + '</span>' : '') +
        '<div class="pg-cart__card-body"><div class="pg-cart__card-title">' + esc(a.cat.title) + '</div>' + stars(a.cat.product_id) + (a.blurb ? '<div class="pg-cart__card-blurb">' + esc(a.blurb) + '</div>' : '') +
        '<button type="button" class="pg-cart__add" data-add="' + a.variantId + '" data-src="upsell:' + esc(a.key) + '" ' + (pc && pc.available === false ? 'disabled' : '') + '>' + (pc && pc.available === false ? '<span>Sold out</span>' : '<span>Add</span>' + (price ? '<b>· ' + price + '</b>' : '')) + '</button></div></li>';
    }).join('');
    return '<div class="pg-cart__label">' + esc(upsellOffer.title || 'Complete your setup') + '<small>Plug-matched to your order</small></div><ul class="pg-cart__grid">' + cards + '</ul>';
  }
  function renderBundle() {
    if (state.holdout) return '';
    var b = (OFFERS.offers || []).filter(function (o) { return o.type === 'bundle' && o.enabled !== false && countryMatch(o.countries, COUNTRY); })[0];
    if (!b) return '';
    var hasReq = !b.requires_product_id || state.lines.some(function (l) { return !l.gift && Number(l.productId) === Number(b.requires_product_id); });
    if (!hasReq) return '';
    var inCart = {};
    state.lines.forEach(function (l) { inCart[Number(l.productId)] = 1; });
    var missing = (b.items || []).map(function (it) { var cat = CATALOG[it.catalog_key]; if (!cat || inCart[Number(cat.product_id)]) return null; var vid = cat.variant_id || (cat.variant_by_plug || {})[state.plug]; return vid ? { vid: Number(vid), qty: it.qty || 1, cat: cat } : null; }).filter(Boolean);
    if (!missing.length || missing.length < (b.items || []).length) return '';
    var total = missing.reduce(function (s, m) { var pc = priceCache[m.vid]; return pc && pc.price != null ? s + pc.price * m.qty : s; }, 0);
    var bd = (OFFERS.offers || []).filter(function (o) { return o.type === 'bundle_discount' && o.enabled !== false && countryMatch(o.countries, COUNTRY) && (o.products || []).every(function (pid) { return (b.items || []).some(function (it) { var c = CATALOG[it.catalog_key]; return c && Number(c.product_id) === Number(pid); }); }); })[0];
    var pct = bd ? Number(bd.percentage) || 0 : 0;
    var priceHtml = total ? (pct ? '<b>\u00b7 ' + money(Math.round(total * (100 - pct) / 100)) + '</b> <s>' + money(total) + '</s>' : '<b>\u00b7 ' + money(total) + '</b>') : '';
    var imgs = missing.map(function (m) { var r = RATINGS[String(m.cat.product_id)]; var im = (r && r.image) || m.cat.image; return im ? '<img src="' + esc(img(im, 120)) + '" alt="">' : ''; }).join('');
    return '<div class="pg-cart__label">Sleep System</div><div class="pg-cart__bundle"><div class="pg-cart__bundle-imgs">' + imgs + '</div><div><div class="pg-cart__bundle-title">' + esc(missing.map(function (m) { return m.cat.title.replace('Earthing Grounding ', '').replace('Premium Grounding ', ''); }).join(' + ')) + '</div><div class="pg-cart__bundle-sub">' + (pct ? '<span class="pg-cart__save">Save ' + pct + '% together</span> \u00b7 ' : '') + esc(b.subtitle || 'Plug-matched, ships with your sheet') + '</div></div><button type="button" class="pg-cart__add" data-bundle="' + esc(missing.map(function (m) { return m.vid + 'x' + m.qty; }).join(',')) + '"><span>Add both</span>' + priceHtml + '</button></div>';
  }
  function renderCode() {
    var cart = state.cart, applied = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
    var open = state.code || state.codeMsg || applied.length;
    return '<details class="pg-cart__code"' + (open ? ' open' : '') + '><summary>Have a discount code?</summary><form data-code-form><input type="text" name="discount" placeholder="Enter code" value="' + esc(state.code) + '" autocomplete="off" aria-label="Discount code"><button type="submit">Apply</button></form>' +
      (state.codeMsg ? '<p class="pg-cart__code-msg' + (/can|could|not/i.test(state.codeMsg) && !/applied/i.test(state.codeMsg) ? ' is-err' : '') + '">' + esc(state.codeMsg) + '</p>' : '') +
      (applied.length && !state.codeMsg ? '<p class="pg-cart__code-msg">' + esc(applied.map(function (c) { return c.code; }).join(', ')) + ' applied</p>' : '') + '</details>';
  }
  function renderEmpty() {
    var tiles = (CFG.empty_tiles || []).map(function (t) { return '<a class="pg-cart__tile" href="' + esc(t.url) + '"><img src="' + esc(t.image) + '" alt="" loading="lazy"><span><span class="pg-cart__tile-title">' + esc(t.title) + '</span><span class="pg-cart__tile-sub">' + esc(t.sub) + '</span></span><span class="pg-cart__tile-arrow">&rarr;</span></a>'; }).join('');
    return '<div class="pg-cart__empty"><p class="pg-cart__empty-title">' + esc(T.empty_title || 'Your cart is empty') + '</p><p>' + esc(T.empty_body || '') + '</p><div class="pg-cart__tiles">' + tiles + '</div></div>';
  }
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }
  function render() {
    if (!el) return;
    var cart = state.cart, ev = state.evalr;
    if (!body || !footer) { body = q('[data-pg-body]'); footer = q('[data-pg-footer]'); band = q('[data-pg-band]'); toastEl = q('[data-pg-toast]'); }
    el.classList.toggle('is-busy', !!state.busy);
    el.classList.toggle('is-empty', !cart || !cart.item_count);
    if (!cart) return;
    renderBand(ev);
    if (!cart.item_count && state.adding) {
      body.innerHTML = '<ul class="pg-cart__lines">' + pendingRow() + '</ul>';
      return;
    }
    if (!cart.item_count) {
      body.innerHTML = renderEmpty();
      footer.hidden = true;
      q('[data-pg-count]').textContent = '';
      return;
    }
    footer.hidden = false;
    var arms = pickArms();
    var saved = state.lines.reduce(function (s, l) { return s + Math.max(0, (l.original || 0) - (l.final || 0)); }, 0);
    var paidLines = state.lines.filter(function (l) { return !l.gift && !l.rebuyGift; });
    var giftLines = state.lines.filter(function (l) { return l.gift || l.rebuyGift; });
    body.innerHTML =
      (state.error ? '<div class="pg-cart__error" role="alert">' + esc(state.error) + '</div>' : '') +
      '<ul class="pg-cart__lines">' + (state.addingRow ? pendingRow() : '') + paidLines.concat(giftLines).map(renderLine).join('') + renderPendingGifts(ev, giftLines) + '</ul>' +
      renderTeaser(ev) +
      renderHero() +
      renderProtection() +
      renderUpsells(arms, ev) +
      renderBundle() +
      renderCode();
    q('[data-pg-subtotal]').textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    var sv = q('[data-pg-saved]');
    var shipTier = (ev.tiers || []).filter(function (t) { return t.type === 'shipping'; })[0];
    var shipFree = !!(shipTier && shipTier.reached);
    sv.hidden = !(saved > 0 || shipFree);
    sv.textContent = (shipFree ? 'Free shipping' : '') + (shipFree && saved > 0 ? ' \u00b7 ' : '') + (saved > 0 ? 'You\u2019re saving ' + money(saved) + ' today' : '');
    q('[data-pg-count]').textContent = '(' + cart.item_count + ')';
    var ship = q('[data-pg-shipping]');
    if (ship) { var st = (ev.tiers || []).filter(function (t) { return t.type === 'shipping'; })[0]; ship.innerHTML = st && st.reached ? '<span class="pg-cart__free">FREE</span>' : 'Calculated at checkout'; }
    loadPrices(arms);
    exposeArms(arms);
    state.error = null;
  }
  function allArmVariantIds() {
    if (!upsellOffer) return [];
    var sheet = paidSheetLine();
    return (upsellOffer.arms || []).map(function (a) {
      var cat = CATALOG[a.catalog_key]; if (!cat) return null;
      if (cat.dynamic === 'same_as_paid_sheet') return sheet ? Number(sheet.variantId) : null;
      return Number(cat.variant_id || (cat.variant_by_plug || {})[state.plug] || (cat.variant_by_plug || {})['AUS/NZ']) || null;
    }).filter(Boolean);
  }
  function loadPrices(arms) {
    // every candidate arm, not just the rendered slots, so the tier-closing arm can be pinned on first paint
    var need = allArmVariantIds().concat(arms.map(function (a) { return a.variantId; }));
    var prot = PRODUCTS.protection; if (prot && prot.variant_id && !state.lines.some(function (l) { return l.isProtection; })) need.push(Number(prot.variant_id));
    var b = (OFFERS.offers || []).filter(function (o) { return o.type === 'bundle'; })[0];
    if (b) (b.items || []).forEach(function (it) { var cat = CATALOG[it.catalog_key]; var vid = cat && (cat.variant_id || (cat.variant_by_plug || {})[state.plug]); if (vid) need.push(Number(vid)); });
    var missing = need.filter(function (v) { return v && !priceCache[v]; });
    if (!missing.length) return;
    Promise.all(missing.map(variantPrice)).then(function () { if (state.open) render(); });
  }
  function exposeArms(arms) {
    if (!state.open || !arms.length) return;
    var sig = arms.map(function (a) { return a.key; }).join(',');
    if (state.exposed[sig]) return;
    state.exposed[sig] = 1;
    track('upsell_impression', { arms: arms.map(function (a) { return a.key; }), plug: state.plug });
  }
  function updateBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !state.cart) return;
    var n = (state.lines || []).filter(function (l) { return !l.gift && !l.rebuyGift; }).reduce(function (t, l) { return t + l.qty; }, 0);
    var cb = bubble.querySelector('.cart-count-bubble');
    if (n > 0) {
      if (!cb) { cb = document.createElement('div'); cb.className = 'cart-count-bubble'; cb.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>'; bubble.appendChild(cb); }
      cb.querySelector('span[aria-hidden]').textContent = n < 100 ? n : '';
      cb.querySelector('.visually-hidden').textContent = n + ' items';
    } else if (cb) cb.remove();
  }

  /* ---------------------------------------------------------------- actions */
  function onBodyClick(e) {
    var t = e.target.closest('[data-qty],[data-remove],[data-add],[data-bundle]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-qty')) {
      var key = t.closest('[data-key]').getAttribute('data-key'), qty = Math.max(0, parseInt(t.getAttribute('data-qty'), 10) || 0);
      track('qty_change', { key: key, qty: qty });
      return mutate(function () { return changeWithGifts(key, qty); });
    }
    if (t.hasAttribute('data-remove')) {
      var k2 = t.getAttribute('data-remove');
      track('remove', { key: k2 });
      return mutate(function () { return changeWithGifts(k2, 0); });
    }
    if (t.hasAttribute('data-add')) {
      var vid = Number(t.getAttribute('data-add')), src = t.getAttribute('data-src') || 'upsell';
      track('upsell_add', { variant_id: vid, src: src, plug: state.plug });
      t.disabled = true; t.textContent = 'Adding…';
      return mutate(function () { return addItems([{ id: vid, quantity: 1, properties: { _pg_src: src } }]).then(function (r) { toast('Added to your cart'); return r; }).catch(function (e2) { track('upsell_add_failed', { variant_id: vid, error: String(e2.message) }); throw e2; }); });
    }
    if (t.hasAttribute('data-bundle')) {
      var items = t.getAttribute('data-bundle').split(',').map(function (s) { var p = s.split('x'); return { id: Number(p[0]), quantity: Number(p[1]) || 1, properties: { _pg_src: 'bundle:sleep_system' } }; });
      track('bundle_add', { variants: items.map(function (i) { return i.id; }) });
      t.disabled = true; t.textContent = 'Adding…';
      return mutate(function () { return addItems(items).then(function (r) { toast('Sleep System added'); return r; }); });
    }
  }
  function onBodyChange(e) {
    var t = e.target;
    if (t.hasAttribute('data-protect')) {
      var prot = PRODUCTS.protection, on = t.checked;
      track('protection', { on: on ? 1 : 0 });
      return mutate(function () {
        if (on) return addItems([{ id: Number(prot.variant_id), quantity: 1, properties: { _pg_src: 'protection' } }]);
        var line = state.lines.filter(function (l) { return l.isProtection; })[0];
        return line ? changeLine(line.key, 0) : null;
      });
    }
  }
  function onBodySubmit(e) {
    var f = e.target.closest('[data-code-form]');
    if (!f) return;
    e.preventDefault();
    var code = (f.querySelector('input[name=discount]').value || '').trim();
    state.code = code; state.codeMsg = '';
    track('code_apply', { code: code });
    mutate(function () {
      return updateCart({ discount: code }).then(function (c) {
        var dc = (c.discount_codes || []).filter(function (x) { return x.code.toLowerCase() === code.toLowerCase(); })[0];
        state.codeMsg = !code ? '' : (dc && dc.applicable ? 'Code applied.' : 'That code can\u2019t be applied to this cart.');
        return c;
      }).catch(function (e2) { state.codeMsg = e2.message || 'Could not apply that code.'; return null; });
    });
  }

  /* ---------------------------------------------------------------- element */
  function CartDrawerEl() { return Reflect.construct(HTMLElement, [], CartDrawerEl); }
  CartDrawerEl.prototype = Object.create(HTMLElement.prototype);
  CartDrawerEl.prototype.constructor = CartDrawerEl;
  CartDrawerEl.prototype.connectedCallback = function () {
    el = this; body = q('[data-pg-body]'); footer = q('[data-pg-footer]'); band = q('[data-pg-band]'); toastEl = q('[data-pg-toast]');
    var self = this;
    q('[data-pg-close]').addEventListener('click', function () { self.close(); });
    q('[data-pg-overlay]').addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) self.close(); });
    body.addEventListener('click', onBodyClick);
    body.addEventListener('change', onBodyChange);
    body.addEventListener('submit', onBodySubmit);
    var express = q('[data-pg-express]'), more = q('[data-pg-express-more]');
    if (express && more) more.addEventListener('click', function () { express.classList.add('is-expanded'); track('express_more'); });
    // only offer "More ways to pay" when the wallets really overflow the single row
    state.checkExpress = function () {
      if (!express) return;
      var clip = express.querySelector('.pg-cart__express-clip'), inner = clip && clip.firstElementChild;
      if (!clip || !inner) return;
      express.classList.toggle('has-more', inner.getBoundingClientRect().height > clip.getBoundingClientRect().height + 6);
    };
    if (express) express.addEventListener('click', function (e) { if (!e.target.closest('[data-pg-express-more]')) track('express_click', { subtotal: state.cart ? state.cart.items_subtotal_price / 100 : null }); }, true);
    var form = q('[data-pg-form]');
    if (form) form.addEventListener('submit', function () { track('checkout_click', { subtotal: state.cart ? state.cart.items_subtotal_price / 100 : null, lines: state.lines.map(function (l) { return { v: l.variantId, q: l.qty, g: l.gift, s: l.src }; }) }); });
    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      cartLink.setAttribute('role', 'button'); cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', function (e) { e.preventDefault(); self.open(cartLink); });
    }
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      try { window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) { if (evt && evt.source === 'pg-cart') return; refresh(); }); } catch (e) {}
    }
    document.addEventListener('cart:refresh', function () { refresh(); });
    // Open the drawer the instant an add-to-cart form is submitted, before Shopify answers,
    // with a pending row; renderContents() then swaps in the real line. If the add fails
    // (sold out etc.) the theme shows its own error and we settle back after a short wait.
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || !/\/cart\/add/.test(f.action) || f.closest('cart-drawer')) return;
      state.adding = true; state.addingRow = true;
      // Paint the row with what the page already knows (title, image, price) instead of a grey skeleton.
      try {
        var mt = document.querySelector('meta[property="og:title"]'), mi = document.querySelector('meta[property="og:image"]');
        var pe = document.querySelector('#pg-sale-price, .price__sale .price-item--sale, .price .price-item--regular, .price-item');
        var h1 = document.querySelector('h1');
        state.addingInfo = { title: (h1 && h1.textContent.trim()) || (mt && mt.content) || '', image: mi && mi.content, price: pe ? pe.textContent.trim() : '' };
      } catch (err) { state.addingInfo = null; }
      self.open(f.querySelector('[type=submit]'));
      clearTimeout(state.addingTimer);
      state.addingTimer = setTimeout(function () { if (state.adding) { state.adding = false; state.addingRow = false; refresh(); } }, 7000);
    }, true);
    // Rebuy-era hooks some snippets still fire.
    document.addEventListener('rebuy:cart.open', function () { self.open(); });
    refresh();
    if (/[?&]pg_cart=open/.test(location.search)) setTimeout(function () { self.open(); }, 300);
  };
  CartDrawerEl.prototype.open = function (triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    state.open = true;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pg-cart-open');
    var close = q('[data-pg-close]'); if (close) setTimeout(function () { close.focus(); }, 50);
    track('open', { source: triggeredBy ? 'icon' : 'add' });
    if (state.checkExpress) { setTimeout(state.checkExpress, 600); setTimeout(state.checkExpress, 2500); }
    state.exposed = {};
    render();
  };
  CartDrawerEl.prototype.close = function () {
    state.open = false;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pg-cart-open');
    track('close');
    if (state.activeElement && state.activeElement.focus) try { state.activeElement.focus(); } catch (e) {}
  };
  CartDrawerEl.prototype.setActiveElement = function (e) { state.activeElement = e; };
  CartDrawerEl.prototype.getSectionsToRender = function () { return []; };
  function optimisticAdd(ps) {
    var items = ps && (ps.items || (ps.variant_id ? [ps] : []));
    if (!items || !items.length) return false;
    var cart = state.cart ? JSON.parse(JSON.stringify(state.cart)) : { items: [], attributes: {}, discount_codes: [] };
    cart.items = cart.items || [];
    items.forEach(function (it) {
      var idx = -1;
      cart.items.forEach(function (x, i) { if (x.key === it.key) idx = i; });
      if (idx >= 0) cart.items[idx] = it; else cart.items.unshift(it);   // add.js returns the line with its new total quantity
    });
    cart.item_count = cart.items.reduce(function (n, x) { return n + x.quantity; }, 0);
    cart.items_subtotal_price = cart.items.reduce(function (n, x) { return n + (x.final_line_price != null ? x.final_line_price : x.line_price || 0); }, 0);
    cart.total_price = cart.items_subtotal_price;
    setCart(cart);
    return true;
  }
  CartDrawerEl.prototype.renderContents = function (parsedState) {
    var self = this;
    track('add_to_cart', { variant_id: parsedState && (parsedState.variant_id || parsedState.id), product_id: parsedState && parsedState.product_id, qty: parsedState && parsedState.quantity });
    state.adding = true; state.addingRow = false; clearTimeout(state.addingTimer);
    try { optimisticAdd(parsedState); } catch (e) {}
    self.open();
    refresh().then(function () { state.adding = false; render(); toast('Added to your cart'); });
  };
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawerEl);
  // Dawn's cart-drawer-items would try to re-render sections; keep any stray element inert.
  if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', function () { return Reflect.construct(HTMLElement, [], arguments.callee); });

  window.PGCart = {
    open: function () { var d = document.querySelector('cart-drawer'); d && d.open(); },
    close: function () { var d = document.querySelector('cart-drawer'); d && d.close(); },
    refresh: refresh,
    add: function (items, src) { return mutate(function () { return addItems(items.map(function (i) { i.properties = Object.assign({ _pg_src: src || 'api' }, i.properties || {}); return i; })); }).then(function () { window.PGCart.open(); }); },
    state: state, config: OFFERS, track: track
  };
})();
